import { Fetch } from '@/utils/fetch';
import { clearToken, setToken } from '@/utils/token';
import { getPageQuery, wait } from '@/utils/utils';
import { history } from '@umijs/max';
import { stringify } from 'qs';

let refreshTokenPromise: Promise<void> | undefined;

async function refreshTokenFn() {
  try {
    await wait(1000);
    const user = await Fetch.post<{ token: string }>('/account/auth/v1/newToken');
    setToken(user);
    refreshTokenPromise = undefined;
  } catch (error) {
    refreshTokenPromise = undefined;
  }
}

export function refreshToken() {
  if (!refreshTokenPromise) {
    refreshTokenPromise = refreshTokenFn();
  }
}

export async function fetchEmailCode(data: {
  email: string;
  type: 'CHANGE_PASSWORD' | 'REGISTER' | 'FORGET_PASSWORD';
}) {
  const result = await Fetch.post('/account/verificationCode/v1', {
    data,
    isPublic: true,
  });
  return result;
}

/**
 * 退出登录，并且将当前的 url 保存
 */
export async function loginOut() {
  // 清理登录信息
  clearToken();
  const { redirect } = getPageQuery();
  if (window.location.pathname !== '/user/login' && !redirect) {
    history.replace({
      pathname: '/auth/login',
      search: stringify({
        redirect: window.location.href,
      }),
    });
  }
}
